module.exports = __webpack_public_path__ + "img/1m.3c785d8d.jpg";